export const environment = {
  production: true,
  authenticated: true,
  hmr: false,
  appConfig: {
    debug: false,
    serverEntryPoint: {
      protocol: 'https',
      server: 'api.visionamos.corresponsalia.digital',
      port: '',
    },
  },
};
